const initialState = {
    token: ""
}

function setAuthReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_TOKEN":
            return {...state, token: action.token}
        default: 
            return state
    }
} 

export default setAuthReducer